import { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { API_BASE_URL } from "../config/api";

const NEUTRAL_MESSAGE = "Als dit e-mailadres bekend is, is er een resetlink verstuurd.";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const API_URL = API_BASE_URL;

  async function handleSubmit(event) {
    event.preventDefault();
    if (loading) return;

    setLoading(true);
    setError("");
    setMessage("");

    try {
      const res = await axios.post(`${API_URL}/api/auth/forgot-password`, {
        email: String(email || "").trim(),
      });
      setMessage(res?.data?.message || NEUTRAL_MESSAGE);
    } catch (err) {
      const status = Number(err?.response?.status || 0);
      if (status === 429) {
        setError(err?.response?.data?.message || "Te veel aanvragen. Probeer later opnieuw.");
      } else {
        setMessage(NEUTRAL_MESSAGE);
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-[100dvh] bg-[#f3f4f6] px-4 py-8">
      <div className="mx-auto w-full max-w-xl rounded-[28px] border border-slate-200 bg-white p-6 shadow-sm sm:p-10">
        <h1 className="mb-3 text-3xl font-semibold tracking-tight text-slate-900">
          Wachtwoord vergeten
        </h1>
        <p className="mb-6 text-sm text-slate-600">
          Vul je e-mailadres in. Als het adres bekend is, sturen we een resetlink.
        </p>

        <form onSubmit={handleSubmit} className="space-y-3">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="E-mailadres"
            className="h-12 w-full rounded-xl border border-slate-200 bg-[#f5f4dd] px-4 text-slate-800 outline-none transition focus:border-blue-400 focus:bg-white"
            autoComplete="email"
            required
          />

          <button
            type="submit"
            disabled={loading}
            className="h-12 w-full rounded-xl bg-[#77aee4] text-base font-semibold text-white transition hover:bg-[#679fd8] disabled:cursor-not-allowed disabled:opacity-70"
          >
            {loading ? "Versturen..." : "Resetlink versturen"}
          </button>
        </form>

        {message ? (
          <div className="mt-4 rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-700">
            {message}
          </div>
        ) : null}

        {error ? (
          <div className="mt-4 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">
            {error}
          </div>
        ) : null}

        <div className="mt-6 text-sm">
          <Link to="/login" className="text-slate-600 underline hover:text-slate-900">
            Terug naar login
          </Link>
        </div>
      </div>
    </div>
  );
}
